<template>
  <div>
    <h1 v-if="this.$route.params.id">Editar Conductor</h1>
    <h1 v-if="!this.$route.params.id">Registrar Conductor</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Foto</label>
                  <base-image-input v-model="$v.imageData.$model" :imagen="getDriverById.profilePicture"/>
                  <small class="text-danger" v-if="!$v.imageData.required">Campo requerido</small>
                  <br>
            </div>
            <div class="col">
              <div class="col-md">
              <a-form-item label="Nombre">
                <a-input
                  placeholder="Nombre"
                  v-model="$v.getDriverById.firstName.$model"
                />
                <small class="text-danger" v-if="!$v.getDriverById.firstName.required">Campo requerido</small>
              </a-form-item>
            </div>
            <div class="col-md">
              <a-form-item label="Apellidos">
                <a-input
                  placeholder="Apellidos"
                  v-model="$v.getDriverById.lastName.$model"
                />
                <small class="text-danger" v-if="!$v.getDriverById.lastName.required">Campo requerido</small>
              </a-form-item>
            </div>
            </div>
            <div class="col-md-6">
              <a-form-item label="Id Tarjetón">
                <a-input placeholder="Id Tarjeta" v-model="$v.getDriverById.cardId.$model" />
                <small class="text-danger" v-if="!$v.getDriverById.cardId.required">Campo requerido</small>
                <small class="text-danger" v-if="!validateRegisteredCardId($v.getDriverById.cardId.$model)">Ya existe un conductor registrado con este tarjetón</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                  label="Fecha de Vencimiento del Tarjetón"
                  has-feedback
                >
                  <a-date-picker placeholder="Selccionar fecha" :disabled-date="disabledDate"  @change="changeTarjetonDate" v-model="$v.getDriverById.cardExpiration.$model" style="width: 100%" />
                  <small class="text-danger" v-if="!$v.getDriverById.cardExpiration.required">Campo requerido</small>
                </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Licencia">
                <a-input placeholder="Licencia" v-model="$v.getDriverById.license.$model" />
                <small class="text-danger" v-if="!$v.getDriverById.license.required">Campo requerido</small>
                <small class="text-danger" v-if="!validateRegisteredLicense($v.getDriverById.license.$model)">Ya existe un conductor registrado con esta licencia</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                  label="Fecha de Vencimiento de la Licencia"
                  has-feedback
                >
                  <a-date-picker placeholder="Selccionar fecha" :disabled-date="disabledDate" @change="changeLicenciaDate" v-model="getDriverById.licenseExpiration" style="width: 100%" />
                  <small class="text-danger" v-if="!$v.getDriverById.licenseExpiration.required">Campo requerido</small>
                </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Teléfono">
                <a-input
                  placeholder="Teléfono"
                  v-model="$v.getDriverById.phoneNumber.$model"
                />
                <small class="text-danger" v-if="!validateRegisteredPhone($v.getDriverById.phoneNumber.$model)">Ya existe un conductor registrado con este número de teléfono</small>
                <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.phoneNumber">Ingresa un número válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Correo electrónico">
                <a-input
                  placeholder="Correo electrónico"
                  v-model="$v.getDriverById.email.$model"
                />
                <small class="text-danger" v-if="!validateRegisteredEmail($v.getDriverById.email.$model)">Ya existe un conductor registrado con este correo electrónico </small>
                <small class="text-danger" v-if="!$v.getDriverById.email.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.getDriverById.email.email">Ingresa un correo electrónico válido</small>
              </a-form-item>
              <!-- {{ validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid }}-->
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!( validateRegisteredCardId($v.getDriverById.cardId.$model) && validateRegisteredLicense($v.getDriverById.license.$model) && validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Registrar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from 'moment'
import BaseImageInput from '@/components/imageInput'
import { required, helpers } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up'
import headers from '@/config/headers.js'
// import { encrypt } from '@/config/headers'
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const DRIVERS_QUERY = gql`
    query getDrivers{
        getDrivers{
            id
            active
            cardExpiration
            cardId
            firstName
            lastName
            license
            licenseExpiration
            phoneNumber
            profilePicture
            email
        },
    }
`
export default {
  data: function () {
    return {
      error: null,
      disabledButton: false,
      imageData: null,
      imageLoadData: null,
      selectedActive: '1',
      optionsActive: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      objectFile: [],
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      getDriverById: {
        active: 0,
        cardExpiration: '',
        cardId: '',
        firstName: '',
        lastName: '',
        license: '',
        licenseExpiration: '',
        phoneNumber: '',
        profilePicture: '',
        email: '',
      },
      phoneNumberEdition: '',
      emailEdition: '',
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredEmailDrivers: [],
      registeredPhoneDrivers: [],
      registeredCardId: {},
      registeredLicense: {},
    }
  },
  apollo: {
    getDriverById: {
      query: gql`
        query getDriverById($id: Int!) {
          getDriverById(id: $id) {
            id
            active
            cardExpiration
            cardId
            firstName
            lastName
            license
            licenseExpiration
            phoneNumber
            profilePicture
            email
          }
        }
      `,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.id) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
      result({ data }) {
        this.getDriverById.phoneNumber = data.getDriverById.phoneNumber.replace('+52', '')
        this.phoneNumberEdition = this.getDriverById.phoneNumber
        this.emailEdition = data.getDriverById.email
        const cardIdEdition = data.getDriverById.cardId
        const licenseEdition = data.getDriverById.license
        this.$apollo.query({ query: DRIVERS_QUERY, context: headers() })
          .then(({ data }) => {
            data.getDrivers.forEach(driver => {
              this.registeredEmailDrivers[driver.email] = 1
              this.registeredPhoneDrivers[driver.phoneNumber] = 1
              this.registeredCardId[driver.cardId] = 1
              this.registeredLicense[driver.license] = 1
            })
            delete this.registeredEmailDrivers[this.emailEdition]
            delete this.registeredPhoneDrivers['+52' + this.phoneNumberEdition]
            delete this.registeredCardId[cardIdEdition]
            delete this.registeredLicense[licenseEdition]
            // console.log('phone and email')
            // console.log(this.emailEdition)
            // console.log(this.registeredEmailDrivers)
            // console.log(this.phoneNumberEdition)
            // console.log(this.registeredPhoneDrivers)
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
  },
  methods: {
    validateRegisteredEmail(email) {
      // console.log(email)
      if (this.registeredEmailDrivers[email]) {
        // console.log('registered email')
        return false
      } else {
        // console.log('not registered email')
        return true
      }
    },
    validateRegisteredPhone(phone) {
      // console.log('+52' + phone)
      if (this.registeredPhoneDrivers['+52' + phone]) {
        // console.log('registered phone')
        return false
      } else {
        // console.log('not registered phone')
        return true
      }
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    changeTarjetonDate(event) {
      if (event) {
        this.getDriverById.cardExpiration = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    changeLicenciaDate(event) {
      if (event) {
        this.getDriverById.licenseExpiration = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    async handleSubmit(e) {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      e.preventDefault()
      if (this.id != null) {
        if (this.imageData.name) {
          this.objectFile.fileExtension = this.imageData.name.split('.').pop()
          this.objectFile.fileUploaded = this.imageData
          const data = await uploadFileS3(this.objectFile)
          this.imageLoadData = data.Location
          /*
            .then(data => {
              this.imageLoadData = data.Location
            })
            .catch(err => {
              console.log(err)
            })
            */
        }
        await this.$apollo.mutate({
          mutation: gql`mutation updateDriver($idEdit: Int, $cardExpiration: String, $firstName: String, $lastName: String, $license: String, $licenseExpiration: String, $phoneNumber: String, $profilePicture: String, $email: String, $cardId: String) {
         updateDriver(id: $idEdit, driver: {
          cardExpiration: $cardExpiration
          firstName: $firstName
          lastName: $lastName
          license: $license
          licenseExpiration: $licenseExpiration
          phoneNumber: $phoneNumber
          profilePicture: $profilePicture
          email: $email
          cardId: $cardId
          }
        ){
          cardExpiration
          firstName
          lastName
          license
          licenseExpiration
          phoneNumber
          profilePicture
          email
          cardId
          }
        }`,
          context: headers(),
          variables: {
            idEdit: parseInt(this.id),
            cardExpiration: this.getDriverById.cardExpiration,
            firstName: this.getDriverById.firstName,
            lastName: this.getDriverById.lastName,
            license: this.getDriverById.license,
            licenseExpiration: this.getDriverById.licenseExpiration,
            phoneNumber: '+52' + this.getDriverById.phoneNumber,
            profilePicture: this.imageLoadData || this.getDriverById.profilePicture,
            email: this.getDriverById.email,
            cardId: this.getDriverById.cardId,
          },
        })
          .then(res => {
            this.$router.push('/conductores/getDrivers')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      } else {
        // console.log(this.getDriverById)
        // console.log(this.defineDate(this.getDriverById.licenseExpiration))

        if (this.imageData != null) {
          this.objectFile.fileExtension = this.imageData.name.split('.').pop()
          this.objectFile.fileUploaded = this.imageData
          const data = await uploadFileS3(this.objectFile)
          this.imageLoadData = data.Location
          // console.log(this.imageLoadData)
          /*
            .then(data => {
              console.log('image')
              console.log(this.imageLoadData)
              this.imageLoadData = data.Location
            })
            .catch(err => {
              console.log(err)
            })
            */
          // console.log('driver data')
          // console.log(this.getDriverById)
        }
        this.$apollo.mutate({
          mutation: gql`mutation createDriver($cardExpiration: String, $firstName: String, $lastName: String, $license: String, $licenseExpiration: String, $phoneNumber: String, $profilePicture: String, $email: String, $cardId: String) {
         createDriver(driver: {
          cardExpiration: $cardExpiration
          firstName: $firstName
          lastName: $lastName
          license: $license
          licenseExpiration: $licenseExpiration
          phoneNumber: $phoneNumber
          profilePicture: $profilePicture
          email: $email
          cardId: $cardId
        }){
          cardExpiration
          firstName
          lastName
          license
          licenseExpiration
          phoneNumber
          profilePicture
          email
          cardId
        }
        }`,
          context: headers(),
          variables: {
            cardExpiration: this.getDriverById.cardExpiration,
            firstName: this.getDriverById.firstName,
            lastName: this.getDriverById.lastName,
            license: this.getDriverById.license,
            licenseExpiration: this.getDriverById.licenseExpiration,
            phoneNumber: '+52' + this.getDriverById.phoneNumber,
            profilePicture: this.imageLoadData,
            email: this.getDriverById.email,
            cardId: this.getDriverById.cardId,
          },
        })
          .then(res => {
            this.$router.push('/conductores/getDrivers')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error.message)
            if (error.message.includes('An account with the given phone_number already exists')) {
              this.mensaje.texto = 'El teléfono que intentas registrar ya existe'
              this.mensaje.color = 'warning'
              this.showAlert()
            } else {
              this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
              this.mensaje.color = 'warning'
              this.showAlert()
            }
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredCardId(cardId) {
      if (this.registeredCardId[cardId.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredLicense(license) {
      if (this.registeredLicense[license.trim()]) {
        return false
      } else {
        return true
      }
    },
    disabledDate(current) {
      return current < moment().add(-1, 'days')
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.$apollo.queries.getDriverById.skip = false
    } else {
      this.$apollo.query({ query: DRIVERS_QUERY, context: headers() })
        .then(({ data }) => {
          data.getDrivers.forEach(driver => {
            this.registeredEmailDrivers[driver.email] = 1
            this.registeredPhoneDrivers[driver.phoneNumber] = 1
            this.registeredCardId[driver.cardId] = 1
            this.registeredLicense[driver.license] = 1
          })
          // console.log('phone and email')
          // console.log(this.emailEdition)
          // console.log(this.phoneNumberEdition)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    /*
    this.getDriverById.active = 0
    this.getDriverById.cardExpiration = ''
    this.getDriverById.cardId = ''
    this.getDriverById.firstName = ''
    this.getDriverById.lastName = ''
    this.getDriverById.license = ''
    this.getDriverById.licenseExpiration = ''
    this.getDriverById.phoneNumber = ''
    this.getDriverById.profilePicture = ''
    this.getDriverById.email = '' */
  },
  validations: {
    imageData: { required },
    getDriverById: {
      firstName: { required },
      lastName: { required },
      cardExpiration: { required },
      cardId: { required },
      phoneNumber: { required, phoneNumber },
      email: { required, email },
      license: { required },
      licenseExpiration: { required },
    },
  },
  components: {
    BaseImageInput,
  },
}
</script>
